<app-chip-creator-custom (newChipEvent)="addChipCode($event)" [htmlContent]="this.message" [label]="'Mensaje'" [showToolBar]="false">
</app-chip-creator-custom>
